import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { isMobile } from 'react-device-detect';
import { Dialog as DialogPrime } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button as ButtonPrime } from 'primereact/button';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import IconButton from '@material-ui/core/IconButton';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { isAfter } from 'date-fns';
import ImpressaoAvisoCirurgia from '../MeusPedidos/ImpressaoAvisoCirurgia';
import ImpressaoPedidoInternacao from '../MeusPedidos/ImpressaoPedidoInternacao';
import ImpressaoSolicitacaoAIHIdentificacaoPaciente from '../MeusPedidos/ImpressaoSolicitacaoAIHIdentificacaoPaciente';
import ImpressaoSolicitacaoAIHJustificativaInternacao from '../MeusPedidos/ImpressaoSolicitacaoAIHJustificativaInternacao';
import ImpressaoSolicitacaoAIHProcedimentoSolicitado from '../MeusPedidos/ImpressaoSolicitacaoAIHProcedimentoSolicitado';
import ImpressaoRPH from '../MeusPedidos/ImpressaoRPH';
import Anotacao from './Anotacao';
import { dominioDemandaCirurgica, dominioNODE } from '../../config/database';
import { tema } from '../../util';
import moment from 'moment';

class BotaoMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      abreModalRejeicao: false,
      abreModalReagendar: false,
      abreModalTrocaStatus: false,
      anchorMenuAcoes: false,
      listaStatus: [],
      statusSelecionado: undefined,
      motivoRejeicao: undefined,
      redirecionaWizard: false,
      abreHistorico: false,
      abreAnotacoes: false,
      listaHistoricoPedido: [],
      dataConfirmadaCirurgia: null,
      dataConfirmadaInternacao: null,
      codigoLeitoInternacao: undefined,
      dataHoraSugeridaReagendamento: null,
      dataInternacaoReagendamento: null,
      listaMotivosReagendamento: [],
      motivoReagendamentoSelecionado: null,
      abreMensagemErro: false,
      mensagemErro: '',
      tituloErro: '',
      abreAvisoCirurgia: false,
      equipeRequisitante: null,
      passoDadosAIH: 0,
      abreImpressaoPedidoInternacao: false,
      abreImpressaoSolicitacaoAIH: false,
      abreImpressaoRPH: false,
      reagendamento: false,
    };
  }

  listMotivosReagendamento() {
    dominioDemandaCirurgica.get('/api/motivoReagendamento').then(
      response => {
        this.setState({ listaMotivosReagendamento: response.data });
      },
      err => {
        this.toast.show({
          severity: 'info',
          summary: 'Erro ao listar motivos para reagendamento!',
          detail: `${err.data.mensagem}`,
          life: 3000,
        });
      }
    );
  }

  componentDidMount() {
    this.listMotivosReagendamento();
  }

  handleAbreHistorico = id => {
    this.consultaHistoricoPedido(id);
    this.setState({
      abreHistorico: true,
      anchorMenuAcoes: null,
    });
  };

  handleAbreAnotacoes = () => {
    this.setState({
      abreAnotacoes: true,
      anchorMenuAcoes: null,
    });
  };

  handleFinalizacaoPedido = () => {
    let bloqueioInternacao = false;

    if (this.props.rowData.modalidadeAtendimento)
      bloqueioInternacao = this.props.rowData.modalidadeAtendimento.recursosBloqueados.some(
        recursoBloqueado =>
          recursoBloqueado.id === this.props.configuracoesRecursoSistema.internacaoPedidoCirurgia
      );

    if (
      this.state.statusSelecionado &&
      this.state.statusSelecionado.id === this.props.configuracoes.statusFinalizado &&
      !bloqueioInternacao
    )
      return (
        <>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              type="datetime-local"
              name="dataConfirmadaCirurgia"
              variant="outlined"
              fullWidth
              required
              id="dataConfirmadaCirurgia"
              label="Data Confirmada da Cirurgia"
              InputLabelProps={{ shrink: true }}
              value={this.state.dataConfirmadaCirurgia}
              onChange={e => {
                const dataConfirmadaCirurgia = new Date(this.state.dataConfirmadaCirurgia);
                const dataConfirmadaInternacao = new Date(this.state.dataConfirmadaInternacao);

                const diferencaMilisegundos = dataConfirmadaInternacao - dataConfirmadaCirurgia;
                const diferencaDias = parseInt(diferencaMilisegundos / (1000 * 60 * 60 * 24), 10);

                const novaDataConfirmadaCirurgia = new Date(e.target.value);
                const novaDataConfirmadaInternacao = novaDataConfirmadaCirurgia;
                novaDataConfirmadaInternacao.setDate(
                  novaDataConfirmadaCirurgia.getDate() + diferencaDias
                );
                novaDataConfirmadaInternacao.setHours(0);

                this.setState({
                  dataConfirmadaCirurgia: e.target.value,
                  dataConfirmadaInternacao: novaDataConfirmadaInternacao.toJSON().slice(0, 10),
                });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              type="date"
              name="dataConfirmadaInternacao"
              variant="outlined"
              fullWidth
              required
              id="dataConfirmadaInternacao"
              label="Data Confirmada da Internação"
              InputLabelProps={{ shrink: true }}
              value={this.state.dataConfirmadaInternacao}
              onChange={e => {
                const novaDataConfirmadaInternacao = new Date(e.target.value);
                novaDataConfirmadaInternacao.setHours(novaDataConfirmadaInternacao.getHours() + 3);
                this.setState({
                  dataConfirmadaInternacao: novaDataConfirmadaInternacao.toJSON().slice(0, 10),
                });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              type="number"
              name="leito"
              variant="outlined"
              fullWidth
              id="leito"
              label="Leito"
              InputLabelProps={{ shrink: true }}
              value={this.state.codigoLeitoInternacao}
              onChange={e => {
                this.setState({ codigoLeitoInternacao: e.target.value });
              }}
            />
          </Grid>
        </>
      );
    if (
      this.state.statusSelecionado &&
      this.state.statusSelecionado.id === this.props.configuracoes.statusFinalizado &&
      bloqueioInternacao
    )
      return (
        <>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              type="datetime-local"
              name="dataConfirmadaCirurgia"
              variant="outlined"
              fullWidth
              required
              id="dataConfirmadaCirurgia"
              label="Data Confirmada da Cirurgia"
              InputLabelProps={{ shrink: true }}
              value={this.state.dataConfirmadaCirurgia}
              onChange={e => {
                const dataConfirmadaCirurgia = new Date(this.state.dataConfirmadaCirurgia);
                const dataConfirmadaInternacao = new Date(this.state.dataConfirmadaInternacao);

                const diferencaMilisegundos = dataConfirmadaInternacao - dataConfirmadaCirurgia;
                const diferencaDias = parseInt(diferencaMilisegundos / (1000 * 60 * 60 * 24), 10);

                const novaDataConfirmadaCirurgia = new Date(e.target.value);
                const novaDataConfirmadaInternacao = novaDataConfirmadaCirurgia;
                novaDataConfirmadaInternacao.setDate(
                  novaDataConfirmadaCirurgia.getDate() + diferencaDias
                );
                novaDataConfirmadaInternacao.setHours(0);

                this.setState({
                  dataConfirmadaCirurgia: e.target.value,
                  dataConfirmadaInternacao: novaDataConfirmadaInternacao.toJSON().slice(0, 10),
                });
              }}
            />
          </Grid>
        </>
      );
    return null;
  };

  handleReagendamentoPedido = () => {
    let bloqueioInternacao = false;

    if (this.props.rowData.modalidadeAtendimento)
      bloqueioInternacao = this.props.rowData.modalidadeAtendimento.recursosBloqueados.some(
        recursoBloqueado =>
          recursoBloqueado.id === this.props.configuracoesRecursoSistema.internacaoPedidoCirurgia
      );
    if (bloqueioInternacao)
      return (
        <>
          <Container className="container-troca-status">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  id="listaMotivosReagendamento"
                  options={this.state.listaMotivosReagendamento}
                  getOptionLabel={option => `${option.descricao}`}
                  onChange={(e, value) => {
                    this.setState({ motivoReagendamentoSelecionado: value });
                  }}
                  value={this.state.motivoReagendamentoSelecionado}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Motivo para Reagendamento"
                      variant="outlined"
                      fullWidth
                      required
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  autoComplete="off"
                  type="datetime-local"
                  name="dataHoraSugerida"
                  variant="outlined"
                  fullWidth
                  required
                  id="dataHoraSugerida"
                  label="Data de Reagendamento da Cirurgia"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.dataHoraSugeridaReagendamento}
                  onChange={e => {
                    this.setState({
                      dataHoraSugeridaReagendamento: e.target.value,
                    });
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </>
      );
    return (
      <>
        <Container className="container-troca-status">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Autocomplete
                id="listaMotivosReagendamento"
                options={this.state.listaMotivosReagendamento}
                getOptionLabel={option => `${option.descricao}`}
                onChange={(e, value) => {
                  this.setState({ motivoReagendamentoSelecionado: value });
                }}
                value={this.state.motivoReagendamentoSelecionado}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Motivo para Reagendamento"
                    variant="outlined"
                    fullWidth
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                autoComplete="off"
                type="datetime-local"
                name="dataHoraSugerida"
                variant="outlined"
                fullWidth
                required
                id="dataHoraSugerida"
                label="Data de Reagendamento da Cirurgia"
                InputLabelProps={{ shrink: true }}
                value={this.state.dataHoraSugeridaReagendamento}
                onChange={e => {
                  this.setState({
                    dataHoraSugeridaReagendamento: e.target.value,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                autoComplete="off"
                type="date"
                name="dataInternacaoReagendamento"
                variant="outlined"
                fullWidth
                required
                id="dataInternacaoReagendamento"
                label="Data de Reagendamento da Internação"
                InputLabelProps={{ shrink: true }}
                value={this.state.dataInternacaoReagendamento}
                onChange={e => {
                  const dataInternacaoReagendamento = new Date(e.target.value);
                  dataInternacaoReagendamento.setHours(dataInternacaoReagendamento.getHours() + 3);

                  this.handleVerificaDataInternacaoMaiorDataCirurgia(dataInternacaoReagendamento);
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </>
    );
  };

  consultaHistoricoPedido(id_pedido) {
    dominioNODE.get(`logpedido/${id_pedido}`).then(res => {
      this.setState({
        listaHistoricoPedido: res.data,
      });
    });
  }

  listarStatusAposPedido = () => {
    dominioDemandaCirurgica.get('/api/listarStatusAposPedido').then(response => {
      this.setState({ listaStatus: response.data });
    });
  };

  limparLocalStorage = () => {
    localStorage.setItem('activeStep', '0');
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.removeItem('faa');
    localStorage.removeItem('atendimento');
    localStorage.removeItem('data_atendimento');
    localStorage.removeItem('seq_atendimento');
    localStorage.removeItem('carater');
    localStorage.removeItem('profissionalResponsavel');
    localStorage.removeItem('dataSugerida');
    localStorage.removeItem('centroCirurgico');
    localStorage.removeItem('lateralidade');
    localStorage.removeItem('indicacaoClinica');
    localStorage.removeItem('prioridade');
    localStorage.removeItem('cidPrincipal');
    localStorage.removeItem('cidsSecundarios');
    localStorage.removeItem('tipoAcomodacao');
    localStorage.removeItem('diariasPrevistas');
    localStorage.removeItem('leitoUTI');
    localStorage.removeItem('tipoAnestesia');
    localStorage.removeItem('caixasOPME');
    localStorage.removeItem('materiaisConsumiveis');
    localStorage.removeItem('caixasCirurgicas');
    localStorage.removeItem('hemoderivados');
    localStorage.removeItem('procedimentoPrincipal');
    localStorage.removeItem('procedimentosSecundarios');
    localStorage.removeItem('documentos');
    localStorage.removeItem('pedidoCirurgia');
    localStorage.removeItem('equipamentos');
    localStorage.removeItem('duracaoEstimada');
    localStorage.removeItem('email');
    localStorage.removeItem('celular');
    localStorage.removeItem('telefone');
    localStorage.removeItem('equipeRequisitante');
    localStorage.removeItem('profissionalRequisitante');
    localStorage.removeItem('exames');
    localStorage.removeItem('dataInternacao');
    localStorage.removeItem('motivoAntecipacaoInternacao');
    localStorage.removeItem('novoPaciente');
    localStorage.removeItem('tipoPedido');
    localStorage.removeItem('aprovacaoAutomatica');
    localStorage.removeItem('slaModelo');
    localStorage.removeItem('demandaId');
    localStorage.removeItem('listaModalidadeAtendimento');
    localStorage.removeItem('reagendamento');
  };

  async handleButtonConferencia() {
    localStorage.setItem('idPedidoConferencia', this.props.rowData.id);
    localStorage.setItem('pendenciasPaciente', JSON.stringify([]));
    localStorage.setItem('pendenciasSolicitacao', JSON.stringify([]));
    localStorage.setItem('pendenciasCirurgia', JSON.stringify([]));
    localStorage.setItem('pendenciasDatas', JSON.stringify([]));
    this.limparLocalStorage();

    if (this.state.reagendamento) {
      localStorage.setItem('reagendamento', 'true');

      localStorage.setItem('activeStep', '2');
    } else {
      localStorage.removeItem('reagendamento');

      localStorage.setItem('activeStep', '4');
    }

    const { id } = this.props.rowData;

    await dominioDemandaCirurgica.get(`api/pedidoCirurgiaGerente/${id}`).then(response => {
      const salaCirurgica = {id: response.data?.salaCirurgia, descricao: `Sala ${response.data?.salaCirurgia}`};
      localStorage.setItem('salaCirurgia', JSON.stringify(salaCirurgica));

      const convenio = {
        id: response.data.atendimento.convenio.id,
        descricao: response.data.atendimento.convenio.descricao,
      };
      localStorage.setItem('convenio', JSON.stringify(convenio));
      localStorage.setItem('peso', response.data.atendimento.peso);
      if (response.data.paciente.cpf) {
        localStorage.setItem('novoPaciente', JSON.stringify(response.data.paciente));
        localStorage.setItem('tipoPedido', '1');
      } else {
        const paciente = {
          ID: response.data.paciente.id,
          CELULAR: response.data.paciente.celular,
          COD_SEXO: response.data.paciente.sexo,
          DAT_NASCIMENTO: response.data.paciente.dataNascimento,
          EMAIL: response.data.paciente.email,
          NOM_MAE: '',
          NOM_PESSOA: response.data.paciente.nome,
          NRO_CPF: '',
          NRO_PRONTUARIO: response.data.paciente.numeroProntuario,
          SEQ_PACIENTE: response.data.paciente.idLegado,
          TELEFONE: response.data.paciente.telefone,
        };
        localStorage.setItem('paciente', JSON.stringify(paciente));
        if (response.data.atendimento.idLegado) localStorage.setItem('tipoPedido', '0');
        else localStorage.setItem('tipoPedido', '1');
      }
      localStorage.setItem('email', response.data.paciente.email);
      localStorage.setItem('telefone', response.data.paciente.telefone);
      localStorage.setItem('celular', response.data.paciente.celular);
      const atendimento = {
        ID: response.data.atendimento.id,
        DAT_HORA_ATENDIMENTO: response.data.atendimento.dataAtendimento,
        NOM_CARATER_ATENDIMENTO: response.data.caraterAtendimento.descricao,
        NRO_FAA: response.data.atendimento.numeroFAA,
        SEQ_ATENDIMENTO: response.data.atendimento.idLegado,
      };
      localStorage.setItem('atendimento', JSON.stringify(atendimento));
      localStorage.setItem('dataSugerida', response.data.dataHoraSugerida);
      localStorage.setItem('centroCirurgico', JSON.stringify(response.data.centroCirurgico));
      localStorage.setItem('lateralidade', response.data.lateralidade);
      localStorage.setItem('indicacaoClinica', response.data.indicacaoClinica);
      localStorage.setItem('prioridade', JSON.stringify(response.data.prioridadeCirurgia));
      localStorage.setItem('cidPrincipal', JSON.stringify(response.data.cidPrincipal));
      localStorage.setItem('cidsSecundarios', JSON.stringify(response.data.cidSecundario));
      localStorage.setItem(
        'tipoAcomodacao',
        JSON.stringify(response.data.internacao.tipoAcomodacao)
      );
      localStorage.setItem('diariasPrevistas', response.data.internacao.diariasPrevistas);
      localStorage.setItem('leitoUTI', JSON.stringify(response.data.internacao.leitoUTI));
      localStorage.setItem('idInternacao', JSON.stringify(response.data.internacao.id));
      localStorage.setItem('tipoAnestesia', JSON.stringify(response.data.tipoAnestesia));
      localStorage.setItem('carater', JSON.stringify(response.data.caraterAtendimento));
      localStorage.setItem(
        'profissionalResponsavel',
        JSON.stringify(response.data.profissionalResponsavel)
      );
      localStorage.setItem(
        'equipeRequisitante',
        JSON.stringify(response.data.profissionalRequisitante.equipe)
      );
      localStorage.setItem(
        'profissionalRequisitante',
        JSON.stringify(response.data.profissionalRequisitante)
      );
      const procedimentoPrincipal = {
        codigo: response.data.procedimentoPrincipal.codigo,
        descricao: response.data.procedimentoPrincipal.descricao,
        id: response.data.procedimentoPrincipal.id,
        idLegado: response.data.procedimentoPrincipal.idLegado,
        quantidade: response.data.quantidadeProcedimentoPrincipal,
      };
      localStorage.setItem('procedimentoPrincipal', JSON.stringify(procedimentoPrincipal));
      const procedimentosSecundarios = [];
      response.data.procedimentoSecundario.forEach(element => {
        procedimentosSecundarios.push({
          codigo: element.procedimento.codigo,
          descricao: element.procedimento.descricao,
          id: element.procedimento.id,
          idLegado: element.procedimento.idLegado,
          quantidade: element.quantidade,
        });
      });
      localStorage.setItem('procedimentosSecundarios', JSON.stringify(procedimentosSecundarios));
      localStorage.setItem('duracaoEstimada', JSON.stringify(response.data.duracaoEstimada));
      localStorage.setItem('dataInternacao', JSON.stringify(moment(response.data.dataInternacao).format('YYYY-MM-DD')));
      localStorage.setItem(
        'motivoAntecipacaoInternacao',
        JSON.stringify(response.data.motivoAntecipacaoInternacao)
      );
      localStorage.setItem(
        'necessariaAvaliacaoAnestesica',
        JSON.stringify(response.data.necessariaAvaliacaoAnestesica)
      );
      localStorage.setItem('motivoAvaliacaoAnestesica', response.data.motivoAvaliacaoAnestesica);
      const pedidoCirurgia = {
        atendimento: null,
        caraterAtendimento: null,
        profissionalResponsavel: null,
        centroCirurgico: null,
        cidPrincipal: null,
        cidSecundario: [],
        codigo: response.data.codigo,
        confirmado: 0,
        dataHoraSugerida: null,
        dataInclusao: response.data.atendimento.dataInclusao,
        duracaoEstimada: null,
        duracaoPrevista: null,
        equipeRequisitante: null,
        id: response.data.id,
        indicacaoClinica: null,
        internacao: null,
        lateralidade: null,
        motivoRejeicao: null,
        paciente: null,
        prioridadeCirurgia: null,
        procedimentoPrincipal: null,
        procedimentoSecundario: [],
        profissionalRequisitante: null,
        quantidadeProcedimentoPrincipal: 1,
        salaCirurgia: null,
        status: { id: 1, descricao: 'PEDIDO', cor: '#52C741' },
        tipoAnestesia: null,
        codigoLeito: response.data.codigoLeitoInternacao,
      };
      localStorage.setItem('pedidoCirurgia', JSON.stringify(pedidoCirurgia));
      localStorage.setItem('internacao', JSON.stringify(response.data.internacao));
      localStorage.setItem(
        'modalidadeAtendimento',
        JSON.stringify(response.data.modalidadeAtendimento)
      );
      dominioDemandaCirurgica
        .get(
          `/api/modalidadesCentroCirurgicoCaraterAtendimento/${response.data.caraterAtendimento.id}/${response.data.centroCirurgico.id}`
        )
        .then(responseListaModalidades => {
          localStorage.setItem(
            'listaModalidadeAtendimento',
            JSON.stringify(responseListaModalidades.data)
          );
        });
    });

    const [
      responseCaixasOPME,
      responsecaixasMaterial,
      responseCaixasCirurgicas,
      responseHemoderivados,
      responseEquipamentos,
      responseExames,
    ] = await Promise.all([
      dominioDemandaCirurgica.get(`/api/itemPedidoCirurgiaCaixaOPME/${this.props.rowData.id}`),
      dominioDemandaCirurgica.get(
        `/api/itemPedidoCirurgiaMaterialConsumivel/${this.props.rowData.id}`
      ),
      dominioDemandaCirurgica.get(`/api/itemPedidoCirurgiaCaixaCirurgica/${this.props.rowData.id}`),
      dominioDemandaCirurgica.get(`/api/itemPedidoCirurgiaHemoderivados/${this.props.rowData.id}`),
      dominioDemandaCirurgica.get(`/api/itemPedidoCirurgiaEquipamento/${this.props.rowData.id}`),
      dominioDemandaCirurgica.get(`/api/itemPedidoCirurgiaExame/${this.props.rowData.id}`),
    ]);

    const caixasOPME = [];
    const materialConsumivel = [];
    const caixasCirurgicas = [];
    const hemoderivados = [];
    const equipamentos = [];
    const exames = [];

    let lista = [];

    lista = responseCaixasOPME.data;
    lista.forEach(caixa =>
      caixasOPME.push({
        id: caixa.item,
        idLegado: caixa.idLegado,
        codigo: caixa.codigo,
        descricao: caixa.descricao,
        tipoItem: caixa.tipoItem,
        quantidade: caixa.quantidade,
        itemEventual: caixa.itemEventual,
        justificativaEventual: caixa.justificativaEventual,
      })
    );

    lista = responsecaixasMaterial.data;
    lista.forEach(material =>
      materialConsumivel.push({
        id: material.item,
        idLegado: material.idLegado,
        codigo: material.codigo,
        descricao: material.descricao,
        tipoItem: material.tipoItem,
        quantidade: material.quantidade,
        itemEventual: material.itemEventual,
        justificativaEventual: material.justificativaEventual,
      })
    );

    lista = responseCaixasCirurgicas.data;
    lista.forEach(caixa =>
      caixasCirurgicas.push({
        id: caixa.item,
        idLegado: caixa.idLegado,
        codigo: caixa.codigo,
        descricao: caixa.descricao,
        tipoItem: caixa.tipoItem,
        quantidade: caixa.quantidade,
      })
    );

    lista = responseHemoderivados.data;
    lista.forEach(hemoderivado =>
      hemoderivados.push({
        id: hemoderivado.item,
        idLegado: hemoderivado.idLegado,
        codigo: hemoderivado.codigo,
        descricao: hemoderivado.descricao,
        tipoItem: hemoderivado.tipoItem,
        quantidade: hemoderivado.quantidade,
        unidadeMedida: hemoderivado.unidadeMedidaObjeto,
      })
    );

    lista = responseEquipamentos.data;
    lista.forEach(equipamento =>
      equipamentos.push({
        id: equipamento.item,
        idLegado: equipamento.idLegado,
        codigo: equipamento.codigo,
        descricao: equipamento.descricao,
        tipoItem: equipamento.tipoItem,
        quantidade: equipamento.quantidade,
      })
    );

    lista = responseExames.data;
    lista.forEach(exame =>
      exames.push({
        id: exame.item,
        idLegado: exame.idLegado,
        codigo: exame.codigo,
        descricao: exame.descricao,
        tipoItem: exame.tipoItem,
        quantidade: exame.quantidade,
      })
    );

    localStorage.setItem('caixasOPME', JSON.stringify(caixasOPME));
    localStorage.setItem('materiaisConsumiveis', JSON.stringify(materialConsumivel));
    localStorage.setItem('caixasCirurgicas', JSON.stringify(caixasCirurgicas));
    localStorage.setItem('hemoderivados', JSON.stringify(hemoderivados));
    localStorage.setItem('equipamentos', JSON.stringify(equipamentos));
    localStorage.setItem('exames', JSON.stringify(exames));

    this.setState({ redirecionaWizard: true });
  }

  handleButtonTrocarStatus = () => {
    this.setState({ anchorMenuAcoes: null });
    this.listarStatusAposPedido();
    this.setState({
      dataConfirmadaCirurgia: this.props.rowData.dataHoraSugerida
        ? this.props.rowData.dataHoraSugerida.slice(0, 19)
        : undefined,
      dataConfirmadaInternacao: this.props.rowData.dataInternacao
        ? this.props.rowData.dataInternacao.slice(0, 10)
        : undefined,
      codigoLeitoInternacao: this.props.rowData.codigoLeitoInternacao,
      abreModalTrocaStatus: true,
    });
  };

  handleButtonRejeitar = () => {
    this.setState({ anchorMenuAcoes: null });
    this.setState({ abreModalRejeicao: true });
  };

  handleButtonReagendar = () => {
    this.setState({ reagendamento: true }, () => {
      this.handleButtonConferencia();
    });

    /*
    this.setState({ anchorMenuAcoes: null });
    this.setState({
      abreModalReagendar: true,
      dataHoraSugeridaReagendamento: this.props.rowData.dataHoraSugerida
        ? this.props.rowData.dataHoraSugerida.slice(0, 19)
        : undefined,
      dataInternacaoReagendamento: this.props.rowData.dataInternacao
        ? this.props.rowData.dataInternacao.slice(0, 10)
        : undefined,
    });
    */
  };

  alterarPassoDadosAIH = passo => {
    this.setState({
      passoDadosAIH: passo,
    });
  };

  handleConfirmarRejeicao = () => {
    const dadosPedido = {
      motivoRejeicao: this.state.motivoRejeicao,
    };

    dominioDemandaCirurgica
      .put(`/api/cancelarPedidoMotivo/${this.props.rowData.id}`, dadosPedido)
      .then(
        () => {
          this.setState({
            abreModalRejeicao: false,
            motivoRejeicao: null,
          });
          const { filtroCentroCirurgico, periodoFiltrado } = this.props.getFiltrosPedidoCirurgia();

          this.props.listarPedidosCirurgia(filtroCentroCirurgico, periodoFiltrado);
        },
        () => { }
      );

    const profissional = JSON.parse(localStorage.getItem('profissional'));

    const dataLog = {
      id_usuario: profissional.userid,
      username: profissional.username,
      id_pedido: this.props.rowData.id,
      tipo: 'Status',
      descricao: `CANCELADO`,
    };

    dominioNODE.post('/logpedido', dataLog).catch(error => {
      console.log(`ERRO AO INCLUIR LOG: ${error}`);
    });
  };

  verificaSeJaForamImpressos = rowData => {
    return (
      rowData.dataImpressaoPedidoInternacao !== null || rowData.dataImpressaoAvisoCirurgico !== null
    );
  };

  handleSubmitReagendamento = async e => {
    e.preventDefault();
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    let finalEfetivoCirurgia = '';
    let agendamentoSalaCirurgiaExistente = false;
    const idProfissionalReagenda = profissional.profissional_id;
    const { dataHoraSugeridaReagendamento, dataInternacaoReagendamento } = this.state;
    const idMotivoReagendamento = this.state.motivoReagendamentoSelecionado.id;
    const dataSugeridaFormatada = format(
      parseISO(dataHoraSugeridaReagendamento),
      "yyyy-MM-dd'T'HH:mm"
    );
    const { id } = this.props.rowData;

    await dominioDemandaCirurgica.get(`api/pedidoCirurgiaGerente/${id}`).then(response => {
      localStorage.setItem('centroCirurgico', JSON.stringify(response.data.centroCirurgico));
    });

    const centroCirurgico = await JSON.parse(localStorage.getItem('centroCirurgico'));

    await Promise.all([
      dominioDemandaCirurgica
        .get(
          `/api/recuperarSalaCirurgica/${dataSugeridaFormatada}/${this.props.rowData.duracaoEstimada}/${this.props.rowData.caraterAtendimento}/${this.props.rowData.profissionalRequisitanteID}/${this.props.rowData.salaCirurgia}/${this.props.rowData.equipeRequisitanteId}/${centroCirurgico.id}`
        )
        .then(
          response => {
            finalEfetivoCirurgia = response.data.finalEfetivoCirurgia;
          },
          err => {
            agendamentoSalaCirurgiaExistente = true;
            this.setState({
              abreMensagemErro: true,
              tituloErro: 'Envio de Pedido Negado',
              mensagemErro: err.response.data.mensagem,
            });
          }
        ),
    ]);

    if (agendamentoSalaCirurgiaExistente) return;

    const dadosPedido = {
      idStatusPedido: this.props.configuracoes.statusReagendado,
      idProfissionalReagenda,
      dataHoraSugeridaReagendamento,
      dataInternacaoReagendamento,
      idMotivoReagendamento,
    };

    Promise.all([
      dominioDemandaCirurgica.put(`/api/alterarStatus/${this.props.rowData.id}`, dadosPedido).then(
        () => {
          this.setState({
            abreModalReagendar: false,
            motivoReagendamentoSelecionado: null,
          });
          const { filtroCentroCirurgico, periodoFiltrado } = this.props.getFiltrosPedidoCirurgia();

          const dadosAgendamentoSalaCirurgia = {
            inicioCirurgia: dataSugeridaFormatada,
          };

          dominioDemandaCirurgica
            .put(
              `/api/agendamentoSalaCirurgia/${this.props.rowData.id}`,
              dadosAgendamentoSalaCirurgia
            )

            .then(() => {
              document.location.reload(true);
            });

          this.props.listarPedidosCirurgia(filtroCentroCirurgico, periodoFiltrado);
        },
        () => {
          this.setState({
            abreModalReagendar: false,
            motivoReagendamentoSelecionado: null,
          });
        }
      ),
    ]);

    const dataLog = {
      id_usuario: profissional.userid,
      username: profissional.username,
      id_pedido: this.props.rowData.id,
      tipo: 'Status',
      descricao: `Reagendamento`,
    };

    dominioNODE.post('/logpedido', dataLog).catch(error => {
      console.log(`ERRO AO INCLUIR LOG: ${error}`);
    });
  };

  handleSubmitTrocaStatus = e => {
    e.preventDefault();
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    let idProfissionalFinaliza;
    let idProfissionalReagenda;
    let dataConfirmadaCirurgia;
    let dataConfirmadaInternacao;
    let codigoLeitoInternacao;
    let dataHoraSugeridaReagendamento;
    let dataInternacaoReagendamento;
    let idMotivoReagendamento;

    if (this.state.statusSelecionado.id === this.props.configuracoes.statusFinalizado) {
      idProfissionalFinaliza = profissional.profissional_id;
      dataConfirmadaCirurgia = this.state.dataConfirmadaCirurgia;
      dataConfirmadaInternacao = this.state.dataConfirmadaInternacao || undefined;
      codigoLeitoInternacao = this.state.codigoLeitoInternacao || undefined;
    } else if (this.state.statusSelecionado.id === this.props.configuracoes.statusReagendado) {
      idProfissionalReagenda = profissional.profissional_id;
      dataHoraSugeridaReagendamento = this.state.dataHoraSugeridaReagendamento;
      dataInternacaoReagendamento = this.state.dataInternacaoReagendamento;
      idMotivoReagendamento = this.state.motivoReagendamentoSelecionado.id;
    }

    const dadosPedido = {
      idStatusPedido: this.state.statusSelecionado.id,
      idProfissionalFinaliza,
      idProfissionalReagenda,
      dataConfirmadaCirurgia,
      dataConfirmadaInternacao,
      codigoLeitoInternacao,
      dataHoraSugeridaReagendamento,
      dataInternacaoReagendamento,
      idMotivoReagendamento,
    };

    Promise.all([
      dominioDemandaCirurgica.put(`/api/alterarStatus/${this.props.rowData.id}`, dadosPedido).then(
        () => {
          this.setState({
            abreModalTrocaStatus: false,
            statusSelecionado: null,
            motivoReagendamentoSelecionado: null,
          });
          const { filtroCentroCirurgico, periodoFiltrado } = this.props.getFiltrosPedidoCirurgia();

          this.props.listarPedidosCirurgia(filtroCentroCirurgico, periodoFiltrado);
          document.location.reload(true);
        },
        () => {
          this.setState({
            abreModalTrocaStatus: false,
            statusSelecionado: null,
            motivoReagendamentoSelecionado: null,
          });
        }
      ),
    ]);

    const dataLog = {
      id_usuario: profissional.userid,
      username: profissional.username,
      id_pedido: this.props.rowData.id,
      tipo: 'Status',
      descricao: `${this.state.statusSelecionado.descricao}`,
    };

    dominioNODE.post('/logpedido', dataLog).catch(error => {
      console.log(`ERRO AO INCLUIR LOG: ${error}`);
    });
  };

  renderFooterDisplayErro = () => {
    return (
      <div>
        <ButtonPrime
          label="OK"
          icon="pi pi-check"
          onClick={() => this.setState({ abreMensagemErro: false })}
          autoFocus
        />
      </div>
    );
  };

  // Impressão Aviso de cirurgia
  handleAvisoCirurgia = () => {
    this.setState({ abreAvisoCirurgia: true });
  };

  closeDialogAvisoCirurgia = () => {
    this.setState({ abreAvisoCirurgia: false });
  };

  // Impressão Pedido de internação
  handlePedidoInternacao = () => {
    this.setState({ abreImpressaoPedidoInternacao: true });
  };

  closeDialogPedidoInternacao = () => {
    this.setState({ abreImpressaoPedidoInternacao: false });
  };

  // Impressão AIH
  handleSolicitacaoAIH = () => {
    this.setState({
      abreImpressaoSolicitacaoAIH: true,
    });
  };

  handleDadosSolicitacaoAIH = () => {
    if (this.state.passoDadosAIH === 0)
      return (
        <ImpressaoSolicitacaoAIHIdentificacaoPaciente
          pedido={this.props.rowData}
          alterarPassoDadosAIH={this.alterarPassoDadosAIH}
          idLegadoPaciente={this.props.rowData?.idLegadoPaciente}
          closeDialog={this.closeDialogAIH}
        />
      );
    if (this.state.passoDadosAIH === 1) {
      const solicitacaoAIH = JSON.parse(localStorage.getItem('solicitacaoAIH'));
      if (!solicitacaoAIH.cidPrincipal)
        solicitacaoAIH.cidPrincipal = this.props.rowData.cidPrincipal;
      if (!solicitacaoAIH.diagnosticoInicial)
        solicitacaoAIH.diagnosticoInicial = this.props.rowData.cidPrincipal.descricao;

      localStorage.setItem('solicitacaoAIH', JSON.stringify(solicitacaoAIH));

      return (
        <ImpressaoSolicitacaoAIHJustificativaInternacao
          alterarPassoDadosAIH={this.alterarPassoDadosAIH}
        />
      );
    }
    if (this.state.passoDadosAIH === 2) {
      const solicitacaoAIH = JSON.parse(localStorage.getItem('solicitacaoAIH'));
      if (!solicitacaoAIH.descricaoProcedimentoSolicitado)
        solicitacaoAIH.descricaoProcedimentoSolicitado = this.props.rowData.procedimento;
      if (!solicitacaoAIH.codigoProcedimento)
        solicitacaoAIH.codigoProcedimento = this.props.rowData.codigoProcedimento;
      if (!solicitacaoAIH.clinica) solicitacaoAIH.clinica = this.props.rowData.equipeRequisitante;
      if (!solicitacaoAIH.caraterInternacao)
        solicitacaoAIH.caraterInternacao = this.props.rowData.caraterAtendimento;
      if (!solicitacaoAIH.documento) solicitacaoAIH.documento = 'CPF';
      if (!solicitacaoAIH.numeroDocumentoProfissional)
        solicitacaoAIH.numeroDocumentoProfissional = this.props.rowData.cpfProfissional;
      if (!solicitacaoAIH.nomeProfissional)
        solicitacaoAIH.nomeProfissional = this.props.rowData.profissionalRequisitante;
      if (!solicitacaoAIH.pedidoCirurgia) solicitacaoAIH.pedidoCirurgia = this.props.rowData.id;

      localStorage.setItem('solicitacaoAIH', JSON.stringify(solicitacaoAIH));

      return (
        <ImpressaoSolicitacaoAIHProcedimentoSolicitado
          alterarPassoDadosAIH={this.alterarPassoDadosAIH}
          handleFechaSolicitacaoAIH={this.handleFechaSolicitacaoAIH}
          listarPedidosCirurgia={this.props.listarPedidosCirurgia}
        />
      );
    }
    return <></>;
  };

  handleFechaSolicitacaoAIH = () => {
    localStorage.removeItem('solicitacaoAIH');
    this.setState({ abreImpressaoSolicitacaoAIH: false, passoDadosAIH: 0 });
  };

  closeDialogAIH = () => {
    this.setState({ abreImpressaoSolicitacaoAIH: false });
  };

  // Impressão RPH
  handlePedidoProdutosHemoterapicos = () => {
    this.setState({
      abreImpressaoRPH: true,
    });
  };

  closeDialogRPH = () => {
    this.setState({ abreImpressaoRPH: false });
    document.location.reload(true);
  };

  // Impressão Encaminhamento Avaliação Anestesia
  handleEncaminhamentoAvaliacaoPreAnestesia = pedido => {
    dominioDemandaCirurgica().then(promise => {
      window.open(`${promise.config.baseURL}/encaminhamentoAvaliacaoPreAnestesia/${pedido}`);
    });
  };

  showWarn = (msg, severity) => {
    this.toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 13000,
    });
  };

  handleVerificaDataInternacaoMaiorDataCirurgia = dataInternacaoReagendamento => {
    if (isAfter(dataInternacaoReagendamento, new Date(this.state.dataHoraSugeridaReagendamento))) {
      this.showWarn('A data da internação não pode ser maior que a data da cirurgia!', 'warn');
      return;
    }
    this.setState({
      dataInternacaoReagendamento: dataInternacaoReagendamento.toJSON().slice(0, 10),
    });
  };

  render() {
    const renderBotaoConferencia = () => {
      if (!this.props.profissionalObservador)
        return (
          <MenuItem
            style={{ borderBottom: 'solid #e7e7e7 1px' }}
            key={`conferencia${this.props.rowData.codigo}`}
            onClick={() => this.handleButtonConferencia()}
            disabled={!this.props.permiteConferencia}
          >
            Conferência
          </MenuItem>
        );
      return null;
    };

    const renderBotaoTrocaStatus = () => {
      if (!this.props.profissionalObservador)
        return (
          <MenuItem
            style={{ borderBottom: 'solid #e7e7e7 1px' }}
            key={`trocarstatus${this.props.rowData.codigo}`}
            onClick={() => this.handleButtonTrocarStatus()}
            disabled={this.verificaSeJaForamImpressos(this.props.rowData)}
          >
            Trocar de Status
          </MenuItem>
        );
      return null;
    };

    const renderBotaoRejeitar = () => {
      if (!this.props.profissionalObservador)
        return (
          <MenuItem
            style={{ borderBottom: 'solid #e7e7e7 1px' }}
            key={`rejeitar${this.props.rowData.codigo}`}
            onClick={() => this.handleButtonRejeitar()}
            disabled={this.props.rowData.primeiraConferencia === null}
          >
            Rejeitar
          </MenuItem>
        );
      return null;
    };

    const renderBotaoReagendar = () => {
      if (!this.props.profissionalObservador)
        return (
          <MenuItem
            style={{ borderBottom: 'solid #e7e7e7 1px' }}
            key={`reagendar${this.props.rowData.codigo}`}
            onClick={() => this.handleButtonReagendar()}
            disabled={this.props.rowData.status_id === this.props.configuracoes.statusCancelado}
          >
            Reagendar
          </MenuItem>
        );
      return null;
    };

    if (this.state.redirecionaWizard) {
      this.props.setRenderWizardGerente(true);
    }
    return (
      <>
        <Toast
          ref={el => {
            this.toastTL = el;
          }}
          position="top-left"
        />

        <Toast
          ref={el => {
            this.toast = el;
          }}
          position="top-right"
        />
        <DialogPrime
          header={this.state.tituloErro}
          visible={this.state.abreMensagemErro}
          style={{ width: '50vw' }}
          onHide={() => this.setState({ abreMensagemErro: false })}
          footer={this.renderFooterDisplayErro()}
        >
          <div>
            <span style={{ whiteSpace: 'pre-line' }}>{this.state.mensagemErro}</span>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Histórico do pedido"
          visible={this.state.abreHistorico}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreHistorico: false })}
        >
          <div>
            <ul>
              {this.state.listaHistoricoPedido.map(log => (
                <li key={log.id}>
                  <strong>{format(parseISO(log.createdAt), 'dd/MM/yy HH:mm')}</strong>
                  <p>{`${log.tipo} --> ${log.descricao}`}</p>
                  Usuário:
                  {log.username}
                </li>
              ))}
            </ul>
          </div>
        </DialogPrime>
        <DialogPrime
          header={`Confirmar Reagendamento do Pedido Nº ${this.props.rowData.codigo}`}
          visible={this.state.abreModalReagendar}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreModalReagendar: false })}
        >
          <p>
            {`Ao confirmar o reagendamento, o pedido nº ${this.props.rowData.codigo} terá seu status alterado.`}
          </p>
          <form onSubmit={this.handleSubmitReagendamento}>
            <div>{this.handleReagendamentoPedido()}</div>
            <div style={{ float: 'right' }}>
              <Button
                variant="contained"
                color="secondary"
                style={{ marginTop: '10px' }}
                type="submit"
              >
                Confirmar
              </Button>
            </div>
          </form>
        </DialogPrime>
        <DialogPrime
          header={`Confirmar Rejeição do Pedido Nº ${this.props.rowData.codigo}`}
          visible={this.state.abreModalRejeicao}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreModalRejeicao: false })}
        >
          <p>
            {`Ao confirmar, o pedido nº ${this.props.rowData.codigo} será rejeitado e esta ação não poderá ser revertida. Caso deseje prosseguir com a rejeição descreva o motivo da rejeição e confirme a ação.`}
          </p>
          <div>
            <TextField
              style={{ textAlign: 'left', marginBottom: '20px', marginTop: '10px' }}
              multiline
              onChange={e => {
                this.setState({ motivoRejeicao: e.target.value });
              }}
              label="Motivo da Rejeição"
              variant="outlined"
              fullWidth
              inputProps={{
                maxLength: 4000,
              }}
              rows={3}
            />
            <div style={{ float: 'right' }}>
              <Button variant="contained" color="secondary" onClick={this.handleConfirmarRejeicao}>
                Confirmar
              </Button>
            </div>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Selecione o Novo Status do Pedido"
          visible={this.state.abreModalTrocaStatus}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreModalTrocaStatus: false, statusSelecionado: null })}
        >
          <p>
            {`Ao selecionar um novo status e confirmar a ação, o pedido nº ${this.props.rowData.codigo} terá seu status alterado para o status escolhido.`}
          </p>
          <div>
            <form onSubmit={this.handleSubmitTrocaStatus}>
              <Container className="container-troca-status">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <Autocomplete
                      id="filtroPrioridade"
                      options={this.state.listaStatus}
                      getOptionLabel={option => `${option.descricao}`}
                      onChange={(e, value) => {
                        this.setState({ statusSelecionado: value });
                      }}
                      value={this.state.statusSelecionado}
                      renderInput={params => (
                        <TextField
                          {...params}
                          label="Status"
                          variant="outlined"
                          fullWidth
                          required
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    />
                  </Grid>
                  {this.handleFinalizacaoPedido()}
                </Grid>
              </Container>
              <div style={{ float: 'right' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginTop: '10px' }}
                  type="submit"
                >
                  Confirmar
                </Button>
              </div>
            </form>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Anotações"
          visible={this.state.abreAnotacoes}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreAnotacoes: false })}
        >
          <>
            <Anotacao
              pedidoCirurgia={this.props.rowData.id}
              profissionalObservador={this.props.profissionalObservador}
            />
          </>
        </DialogPrime>
        <span className="p-column-title">Ações</span>
        <span style={{ margin: 'auto' }}>
          <IconButton
            onClick={event => this.setState({ anchorMenuAcoes: event.currentTarget })}
            style={{ marginRight: '1px', backgroundColor: tema.gelado, color: 'white' }}
            className="botao-favoritos"
          >
            <ViewHeadlineIcon />
          </IconButton>
          <Menu
            id="menu-acao-pedidos-cirurgias"
            anchorEl={this.state.anchorMenuAcoes}
            keepMounted
            open={Boolean(this.state.anchorMenuAcoes)}
            onClose={() => this.setState({ anchorMenuAcoes: null })}
            MenuListProps={{ style: { width: isMobile ? '60vw' : '20vw' } }}
          >
            {renderBotaoConferencia()}
            {renderBotaoTrocaStatus()}
            {renderBotaoReagendar()}
            {renderBotaoRejeitar()}
            <MenuItem
              style={{ borderBottom: 'solid #e7e7e7 1px' }}
              key={`historico${this.props.rowData.codigo}`}
              onClick={() => this.handleAbreHistorico(this.props.rowData.id)}
            >
              Histórico
            </MenuItem>
            <MenuItem
              style={{ borderBottom: 'solid #e7e7e7 1px' }}
              key={`anotacao${this.props.rowData.codigo}`}
              onClick={() => this.handleAbreAnotacoes()}
            >
              Anotações
            </MenuItem>

            {this.props.rowData.status === 'FINALIZADO' && (
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Impressões</Typography>
                </AccordionSummary>
                <MenuItem
                  style={{
                    borderBottom: 'solid #e7e7e7 1px',
                    display: this.props.rowData.status === 'FINALIZADO' ? '' : 'none',
                  }}
                  key={1}
                  onClick={() => this.handleAvisoCirurgia(this.props.rowData.id)}
                >
                  Aviso de Cirurgia
                </MenuItem>

                <MenuItem
                  style={{
                    borderBottom: 'solid #e7e7e7 1px',
                    display: this.props.rowData.status === 'FINALIZADO' ? '' : 'none',
                  }}
                  key={1}
                  onClick={() => this.handlePedidoInternacao(this.props.rowData.id)}
                  disabled={this.props.rowData.idLegadoInternacao}
                >
                  Pedido de Internação
                </MenuItem>

                <MenuItem
                  style={{
                    borderBottom: 'solid #e7e7e7 1px',
                    display: this.props.rowData.pedidoCampanha ? '' : 'none',
                  }}
                  key={1}
                  onClick={() => this.handleSolicitacaoAIH(this.props.rowData.id)}
                >
                  Solicitação de AIH
                </MenuItem>

                <MenuItem
                  style={{
                    borderBottom: 'solid #e7e7e7 1px',
                    display: this.props.rowData.possuiHemoterapico ? '' : 'none',
                  }}
                  key={1}
                  onClick={() => this.handlePedidoProdutosHemoterapicos(this.props.rowData.id)}
                >
                  Pedido de Produtos Hemoterápicos
                </MenuItem>

                <MenuItem
                  style={{
                    borderBottom: 'solid #e7e7e7 1px',
                    display: this.props.rowData.necessariaAvaliacaoAnestesica ? '' : 'none',
                  }}
                  key={1}
                  onClick={() =>
                    this.handleEncaminhamentoAvaliacaoPreAnestesia(this.props.rowData.id)
                  }
                >
                  Encaminhamento Avaliação Pré-Anestesia
                </MenuItem>
              </Accordion>
            )}
          </Menu>
        </span>
        <DialogPrime
          header="Impressão do Pedido de Internação"
          visible={this.state.abreImpressaoPedidoInternacao}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreImpressaoPedidoInternacao: false })}
        >
          <>
            <ImpressaoPedidoInternacao
              pedido={this.props.rowData}
              closeDialog={this.closeDialogPedidoInternacao}
            />
          </>
        </DialogPrime>
        <DialogPrime
          header="Solicitação de AIH"
          visible={this.state.abreImpressaoSolicitacaoAIH}
          style={{ width: '65vw' }}
          onHide={this.handleFechaSolicitacaoAIH}
        >
          {this.handleDadosSolicitacaoAIH()}
        </DialogPrime>
        <DialogPrime
          header="Impressão do Aviso de Cirurgia"
          visible={this.state.abreAvisoCirurgia}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreAvisoCirurgia: false })}
        >
          <>
            <ImpressaoAvisoCirurgia
              pedido={this.props.rowData}
              closeDialog={this.closeDialogAvisoCirurgia}
              listarPedidosCirurgia={this.props.listarPedidosCirurgia}
            />
          </>
        </DialogPrime>
        <DialogPrime
          header="Impressão da RPH"
          visible={this.state.abreImpressaoRPH}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreImpressaoRPH: false })}
        >
          <>
            <ImpressaoRPH
              pedido={this.props.rowData}
              closeDialog={this.closeDialogRPH}
              listarPedidosCirurgia={this.listarPedidosCirurgia}
            />
          </>
        </DialogPrime>
      </>
    );
  }
}

export default BotaoMenu;
